import { Instance, types } from 'mobx-state-tree'

const QrAgentSession: any = types
  .model('Session', {
    appAccessToken: types.optional(types.string, ''),
    appRefreshToken: types.optional(types.string, ''),
    appAccessTokenExpiry: types.optional(types.number, -1),
    appRefreshTokenExpiry: types.optional(types.number, -1),
    appIdToken: types.optional(types.string, ''),
    authorizationCode: types.optional(types.string, ''),
    userAccessToken: types.optional(types.string, ''),
    userRefreshToken: types.optional(types.string, ''),
    userAccessTokenExpiry: types.optional(types.number, -1),
    userRefreshTokenExpiry: types.optional(types.number, -1),
    userIdToken: types.optional(types.string, ''),
    isVerified: types.optional(types.boolean, false),
    initialized: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    updateAppTokens(tokens: any) {
      const own = self
      own.appAccessToken = tokens?.session?.accessToken?.tokenValue ?? ''
      own.appRefreshToken = tokens?.session?.refreshToken?.tokenValue ?? ''
      own.appAccessTokenExpiry = +tokens?.session?.accessToken?.expiresIn
      own.appRefreshTokenExpiry = +tokens?.session?.refreshToken?.expiresIn
      own.appIdToken = tokens?.session?.appIdentifierToken ?? ''
      own.authorizationCode = tokens?.authorizationCode ?? ''
      window.localStorage.setItem('csoSessData', JSON.stringify(self))
    },
    updateUserTokens(tokens: any) {
      const own = self
      own.userAccessToken = tokens?.session?.accessToken?.tokenValue ?? ''
      own.userRefreshToken = tokens?.session?.refreshToken?.tokenValue ?? ''
      own.userAccessTokenExpiry = +tokens?.session?.accessToken?.expiresIn
      own.userRefreshTokenExpiry = +tokens?.session?.refreshToken?.expiresIn
      own.userIdToken = tokens?.session?.identifierToken ?? ''
      window.localStorage.setItem('csoSessData', JSON.stringify(self))
    },
    resetAccessToken(): void {
      const own = self
      own.userAccessToken = ''
      own.userIdToken = ''
      own.userRefreshToken = ''
      own.userAccessTokenExpiry = -1
      own.userRefreshTokenExpiry = -1
      own.isVerified = false
      own.appAccessToken = ''
      own.appRefreshToken = ''
      own.appAccessTokenExpiry = -1
      own.appRefreshTokenExpiry = -1
      own.appIdToken = ''
      own.authorizationCode = ''
      window.localStorage.removeItem('csoSessData')
    },
    setSessionVerified(isUserVerified: boolean): void {
      self.isVerified = isUserVerified
    },
    updateSessionData(data: any) {
      self.appAccessToken = data.appAccessToken
      self.appRefreshToken = data.appRefreshToken
      self.appAccessTokenExpiry = data.appAccessTokenExpiry
      self.appRefreshTokenExpiry = data.appRefreshTokenExpiry
      self.appIdToken = data.appIdToken

      self.userRefreshToken = data.userRefreshToken
      self.userRefreshTokenExpiry = data.userRefreshTokenExpiry
      self.userAccessTokenExpiry = data.userAccessTokenExpiry
      self.userIdToken = data.userIdToken
      self.userAccessToken = data.userAccessToken
      // self.jfsUserId = data.jfsUserId
      self.isVerified = data.isVerified
      window.localStorage.setItem('csoSessData', JSON.stringify(self))
    },
    setInitialized: (val: boolean) => {
      self.initialized = val
    },
  }))
  .views((self) => ({
    get getTokens() {
      return {
        appAccessToken: self.appAccessToken,
        appIdToken: self.appIdToken,
        userAccessToken: self.userAccessToken,
        userIdToken: self.userIdToken,
      }
    },
    presentScreenName() {
      return self.navigatedScreen
    },
  }))

const sessionDataInitial = QrAgentSession.create({
  userAccessToken: '',
  userRefreshToken: '',
  userAccessTokenExpiry: -1,
  userRefreshTokenExpiry: -1,
  isVerified: false,
  lastLoginDate: '',
  appAccessToken: '',
  appIdToken: '',
  userIdToken: '',
  appRefreshToken: '',
  appAccessTokenExpiry: -1,
  appRefreshTokenExpiry: -1,
})

export type SessionV2 = Instance<typeof QrAgentSession>
export { QrAgentSession, sessionDataInitial }
